import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StoreServiceService } from '@teem/app/core/services/store-service.service';
@Component({
  selector: 'app-create-store-modal',
  templateUrl: './create-store-modal.component.html',
  styleUrls: ['./create-store-modal.component.scss']
})
export class CreateStoreModalComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    public storeService : StoreServiceService
  ) { }

  ngOnInit(): void {
  }

  gotoStore(){
    window.location.href = '/store';
  }

  setBranches(value :any = 1){
    this.storeService.setStoreAsBranches({'is_branch':value}).subscribe((data:any)=> {
      if(data.status == 'success'){
        this.gotoStore()
      }
    })
  }
}
